export const IS_BUSY = '@busy/IS_BUSY';
export type BUSY = typeof IS_BUSY;

export const IS_CALLED = '@called/IS_CALLED';
export type CALLED = typeof IS_CALLED;

export const ACTIVEUPDATE = '@update/ACTIVEUPDATE';
export type UPDATE = typeof ACTIVEUPDATE;

export const IS_LOADING_ASSIGN_CAR = '@loadingAssignCar/IS_LOADING_ASSIGN_CAR';
export type LOADING_ASSIGN_CAR = typeof IS_LOADING_ASSIGN_CAR;

export const WIDTH_SIDEBAR = '@sidebar/WIDTH_SIDEBAR';
export type WIDTHSIDEBAR = typeof WIDTH_SIDEBAR;

export const INFO_DRIVER_TO_CAR = '@dataDriverToCar/INFO_DRIVER_TO_CAR';
export type DRIVER_TO_CAR = typeof INFO_DRIVER_TO_CAR;

export const DISPLAY_OFFLINE_PAYMENT = '@btn/DISPLAY_OFFLINE_PAYMENT';
export type OFFLINE_PAYMENT = typeof DISPLAY_OFFLINE_PAYMENT;

export const IS_OPEN_POPUP = '@popup/IS_OPEN_POPUP';
export type OPEN_POPUP = typeof IS_OPEN_POPUP;

export const LISTVEHICLE = '@list/LISTVEHICLE';
export type LIST = typeof LISTVEHICLE;

export const STATE_CYCLE = '@cycle/STATE_CYCLE';
export type CYCLE = typeof STATE_CYCLE;

export const INFO_PAY = '@pay/INFO_PAY';
export type PAY = typeof INFO_PAY;

export const OLD_URL = '@back/OLD_URL';
export type OLD = typeof OLD_URL;

export interface SetOldUrl {
  type: OLD;
  payload: {
    oldUrl: any,
  }
}

export function setOldUrl(oldUrl: any): SetOldUrl {
  return {
    type: OLD_URL,
    payload: {
      oldUrl: oldUrl
    }
  }
}

export interface SetPayInfo {
  type: PAY;
  payload: {
    infoPay: any,
  }
}

export function setPayInfo(infoPay: any): SetPayInfo {
  return {
    type: INFO_PAY,
    payload: {
      infoPay: infoPay
    }
  }
}

export interface SetOpenPopup {
  type: OPEN_POPUP;
  payload: {
    isOpenPopup: any,
  }
}

export function setOpenPopup(isOpenPopup: any): SetOpenPopup {
  return {
    type: IS_OPEN_POPUP,
    payload: {
      isOpenPopup: isOpenPopup
    }
  }
}

export interface SetStateCycle {
  type: CYCLE;
  payload: {
    cycleManager: any,
  }
}

export function setStateCycle(cycleManager: any): SetStateCycle {
  return {
    type: STATE_CYCLE,
    payload: {
      cycleManager: cycleManager
    }
  };
}

export interface SetList {
  type: LIST;
  payload: {
    listVehicle: any,
  }
}

export function setList(listVehicle: any): SetList {
  return {
    type: LISTVEHICLE,
    payload: {
      listVehicle: listVehicle
    }
  };
}

export interface SetOfflinePayment {
  type: OFFLINE_PAYMENT;
  payload: {
    displayOffline: any,
  }
}

export function setOfflinePayment(displayOffline: any): SetOfflinePayment {
  return {
    type: DISPLAY_OFFLINE_PAYMENT,
    payload: {
      displayOffline: displayOffline
    }
  };
}

export interface SetIsBusy {
  type: BUSY;
  payload: {
    isBusy: any,
  }
}

export function setIsBusy(isBusy: any): SetIsBusy {
  return {
    type: IS_BUSY,
    payload: {
      isBusy: isBusy
    }
  };
}

export interface SetUpdate {
  type: UPDATE;
  payload: {
    isUpdate: any,
  }
}

export function setUpdate(isUpdate: any): SetUpdate {
  return {
    type: ACTIVEUPDATE,
    payload: {
      isUpdate: isUpdate
    }
  };
}

export interface SetCalled {
  type: CALLED;
  payload: {
    isCalled: any,
  }
}

export function setCalled(isCalled: any): SetCalled {
  return {
    type: IS_CALLED,
    payload: {
      isCalled: isCalled
    }
  };
}

export interface SetLoadingAssignCar {
  type: LOADING_ASSIGN_CAR;
  payload: {
    isLoadingAssignCar: any,
  }
}

export function setLoadingAssignCar(isLoadingAssignCar: any): SetLoadingAssignCar {
  return {
    type: IS_LOADING_ASSIGN_CAR,
    payload: {
      isLoadingAssignCar: isLoadingAssignCar
    }
  };
}

export interface SetWidthSidebar {
  type: WIDTHSIDEBAR;
  payload: {
    sizeSideBar: false,
  }
}

export function setWidthSide(sizeSideBar: any): SetWidthSidebar {
  return {
    type: WIDTH_SIDEBAR,
    payload: {
      sizeSideBar: sizeSideBar
    }
  };
}

export interface SetDriverToCar {
  type: DRIVER_TO_CAR;
  payload: {
    driverToCar: any,
  }
}

export function setDriverToCary(driverToCar: any): SetDriverToCar {
  return {
    type: INFO_DRIVER_TO_CAR,
    payload: {
      driverToCar: driverToCar
    }
  };
}